import { VApp } from 'vuetify/lib/components/VApp';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c(VMain,[_c(VFadeTransition,{attrs:{"mode":"out-in"}},[_vm._t("default")],2),_c('core-footer')],1),_c('core-snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }